import React, { useRef, useEffect, useCallback } from "react";
import ZoneFrontiere, { Position as PositionZF } from "@/modules/reeducation/ZoneFrontiere";
import { useParams } from "react-router-dom";
import { evolveState } from "../selection/ZFEvolve";
import { updateSelection } from "@/utils/updateSelection";
import { saveResultsModules } from "@/utils/saveResultsModules";

interface LauncherZoneFrontiereProps {
  caseSize: number;
  isPausedAndNotFullScreenRef: React.MutableRefObject<boolean>;
  nextModule: () => void;
  predeterminedCells: string[];
  inputCaseSession: { [key: string]: string[] };
  selectionId: string;
  role: "practitioner" | "patient";
  status: "EN_COURS" | "PREVUE" | "REALISEE";
  targetEnCours_Zf_Bilan: PositionZF[] | null;
  initialTargetsLengthEncours_Zf_Bilan: number | null;
  resultsZF: Result[] | null;
}

interface Result {
  position: string;
  reactionTime: number | string;
}

const LauncherZoneFrontiere: React.FC<LauncherZoneFrontiereProps> = ({
  caseSize,
  isPausedAndNotFullScreenRef,
  nextModule,
  predeterminedCells,
  inputCaseSession,
  selectionId,
  role,
  status,
  targetEnCours_Zf_Bilan,
  initialTargetsLengthEncours_Zf_Bilan,
  resultsZF
}) => {
  const { sessionId, patientId } = useParams<{
    sessionId: string;
    patientId: string;
  }>();
  const zoneFrontiereRef = useRef<{ start: () => void } | null>(null);
  // const resultsRef = useRef<Result[]>([]);

  // const handleSetResults = useCallback(
  //   (newResults: Result[]) => {
  //     resultsRef.current = [...resultsRef.current, ...newResults];

  //     if (resultsRef.current.length === predeterminedCells.length) {
  //       console.log("Final Results Recorded:", resultsRef.current);
  //       // Once all results are recorded, trigger the next module
  //       //   nextModule();
  //     }
  //   },
  //   [predeterminedCells.length]
  // );

  useEffect(() => {
    // Automatically start the target showing process on mount
    if (zoneFrontiereRef.current) {
      zoneFrontiereRef.current.start();
    }
  }, [isPausedAndNotFullScreenRef]);

  if (!sessionId || (role === "practitioner" && !patientId)) {
    console.error("Session ID or Patient ID is missing.");
    return null; // Return early or handle the error appropriately
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const saveResults = useCallback(
    async (resultZF: Result[]) => {
      const fieldsToUpdate = [
        { field: "resultsZF", value: JSON.stringify(resultZF) },
        // { field: "sessionDate", value: new Date().toISOString() },
        // { field: "status", value: "REALISEE" },
        // { field: "visualFieldInput", value: JSON.stringify(inputCaseSession) },
        { field: "targetEnCours_Zf_Bilan", value: null },
        { field: "initialTargetsLengthEncours_Zf_Bilan", value: null }
      ];

      saveResultsModules(fieldsToUpdate, sessionId.toString(), role);
      const evolvedSelection = evolveState(resultZF, inputCaseSession);
      try {
        await updateSelection(
          role,
          selectionId,
          evolvedSelection,
          role === "practitioner" ? patientId : undefined
        );
      } catch (error: unknown) {
        if (error instanceof Error) {
          console.error("Error updating selection:", error.message);
        } else {
          console.error("Unexpected error", error);
        }
      }
    },
    [sessionId, predeterminedCells]
  );

  const intermediateSave = async (IntermediatResults: Result[], targetEnCours: PositionZF[], initialTargetsLength: number) => {

    const fieldsToUpdate = [
      { field: "resultsZF", value: JSON.stringify(IntermediatResults) },
      { field: "targetEnCours_Zf_Bilan", value: JSON.stringify(targetEnCours) },
      { field: "initialTargetsLengthEncours_Zf_Bilan", value: initialTargetsLength }
    ];

    saveResultsModules(fieldsToUpdate, sessionId.toString(), role);
  };

  return (
    <ZoneFrontiere
      ref={zoneFrontiereRef}
      caseSize={caseSize}
      isPausedAndNotFullScreenRef={isPausedAndNotFullScreenRef}
      predeterminedCells={predeterminedCells}
      saveResults={saveResults}
      nextModule={nextModule}
      intermediateSave={intermediateSave}
      status={status}
      targetEnCours_Zf_Bilan={targetEnCours_Zf_Bilan}
      initialTargetsLengthEncours_Zf_Bilan={initialTargetsLengthEncours_Zf_Bilan}
      resultsZF={resultsZF}
    />
  );
};

export default LauncherZoneFrontiere;
